var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.9 16.2h6.2a1.4 1.4 0 010 2.8H8.9a1.4 1.4 0 010-2.8zm-1.8-5.6h9.8a1.4 1.4 0 010 2.8H7.1a1.4 1.4 0 110-2.8zM4.4 5h15.2a1.4 1.4 0 010 2.8H4.4a1.4 1.4 0 110-2.8z"
  })));
}
export default SvgFilter;